module.exports = __webpack_public_path__ + "img/fill-illustration.e2214268.svg";